import * as React from 'react';
import { Text } from '../components/forms';
import { Link } from 'react-router-dom';
import Page from '../components/Page';
import Section from '../components/Section';
import Box from '../components/Box';
import { ButtonStyle } from '../components/Button';
import { ActionBar, ActionBarStyle } from '../components/ActionBar';
import { Invitation } from '../invitation';
import { ErrorFlash, SuccessFlash } from '../components/Flash';
import { ProfileContext, ProfileManager } from '../profile';
import { useRequestAsync, getHeaders } from '../api/client';

type Props = {
  invitation: Invitation;
};

const newInvitation: Invitation = {
  id: null,
  company_id: null,
  name: null,
  email: null,
  created_at: null,
  updated_at: null,
};

const update = (context: ProfileManager) => {
  return useRequestAsync((data: Invitation) => ({
    url: '/invitations/new',
    method: 'POST',
    body: JSON.stringify(data),
    headers: getHeaders(context),
  }));
};

const setValue = (obj: Invitation, onChange: Function) => (
  field: string,
  newValue: any,
) =>
  onChange(
    Object.assign({}, obj, {
      [field]: newValue,
    }),
  );

export default function NewInvitation(props: Props) {
  const context = React.useContext(ProfileContext);
  const [invitation, setInvitation] = React.useState(newInvitation);

  const [state, submit] = update(context);

  const handleFormSubmit = () =>
    submit({
      ...newInvitation,
      ...invitation,
    });

  return (
    <Page
      title="A new invitation"
      subtitle="Send invites to members of your organisation"
    >
      <div className="flex justify-center ml-auto mr-auto">
        <Link
          to="/invitations"
          className="f5 link br-pill bg-near-white hover-bg-black-10 ph4 pv3 mh2 b black"
        >
          ← Back to Invitations
        </Link>
      </div>
      {state.error && <ErrorFlash error={state.error} />}
      {state.complete && state.data && (
        <SuccessFlash text="Invitation has been sent" />
      )}
      <form onSubmit={handleFormSubmit} id="invitation">
        <Section title="Basic details">
          <div className="flex">
            <div className="flex-auto w-50 pr2">
              <Text
                label="Name"
                field={['name']}
                id="name"
                defaultValue={invitation.name}
                onValueChange={setValue(invitation, setInvitation)}
              />
            </div>
            <div className="flex-auto w-50 pl2">
              <Text
                label="Email"
                field={['email']}
                id="email"
                defaultValue={invitation.email}
                onValueChange={setValue(invitation, setInvitation)}
              />
            </div>
          </div>
        </Section>
        <ActionBar
          className={ActionBarStyle.alignCenter}
          actions={[
            {
              className: ButtonStyle.Confirm,
              label: 'Save',
              handler: handleFormSubmit,
            },
          ]}
        />
      </form>
    </Page>
  );
}
